module.exports = __webpack_public_path__ + "static/jorge_lima-23a5d2e14af5bf4cfc8ba8cff4da2aeb.png";